<template>
  <div v-if="visible">
    <v-autocomplete
      v-model="location"
      append-icon=""
      hide-details
      :items="foundGeoLocations"
      item-text="name"
      item-value="key"
      :loading="searching"
      prepend-inner-icon="mdi-magnify"
      outlined
      placeholder="Vyhledejte místo"
      return-object
      :search-input.sync="query"
      @input="onGeoLocationSelect"
    >
      <template v-slot:append>
        <v-icon color="red" @click="onDeleteClick">
          mdi-delete-outline
        </v-icon>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

export default {
  name: "GeoLocationSearch",
  props: {
    clearAfterSelect: {
      type: Boolean,
      default: true,
    },
    geoLocationType: {
      type: String,
      default: "locations",
    },
    // minimum length of query to start search
    minQueryLength: {
      type: Number,
      default: 3,
    },
    // minimum delay after last key pressed to start search; in miliseconds
    timeDelay: {
      type: Number,
      default: 250,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      location: null,
      query: null,
      timeout: null,
    }
  },
  computed: {
    ...get("targeting", ["searching"]),
    ...sync("targeting", ["foundGeoLocations"]),
  },
  methods: {
    ...call("targeting", ["searchGeoLocations"]),
    onDeleteClick() {
      this.$emit("delete")
    },
    onGeoLocationSelect(val) {
      if (this.clearAfterSelect) {
        this.foundGeoLocations = []
        this.location = null
        this.query = null
      }

      this.$emit("select", val)
    },
  },
  watch: {
    query(val) {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      if ((val && val.length < this.minQueryLength) || this.location) {
        return
      }

      if (this.timeDelay > 0) {
        this.timeout = setTimeout(() => {
          this.searchGeoLocations({ query: val, type: this.geoLocationType })
        }, this.timeDelay)
      }
    },
  },
}
</script>
